export default {
  modal_view: {
    evid: 2077,
    src: 5,
    endpoint: 'site-members',
    fields: {
      flow: 'string',
      modal_name: 'string',
    },
  },
  modal_click: {
    evid: 2079,
    src: 5,
    endpoint: 'site-members',
    fields: {
      flow: 'string',
      modal_name: 'string',
      cta_type: 'string',
    },
  },
} as const;
